import styled from "styled-components";

export const SummaryListRow = styled.div`
  @media (min-width: 40.0625em) {
    display: table-row;
  }
`;
